import { SipRecommendationActionType } from '../../api/common.types'
import type { SipPlanRecommendationContainerInput } from '../open/planRecommendationOpen'
import { useSipPlanRecommendation } from '../useSipPlanRecommendation'
import { SipStopPlanRecommendationSheet } from './SipStopPlanRecommendationSheet'

export function SipStopPlanRecommendationContainer(input: SipPlanRecommendationContainerInput) {
  const { onDismiss, isin, totalIdealSipAmount, recommendation, manageSipCta } = input
  const { planDetails, isLoading, isFetchFailed, onRetry } = useSipPlanRecommendation(
    isin,
    SipRecommendationActionType.STOP,
    totalIdealSipAmount,
    true
  )

  return (
    <SipStopPlanRecommendationSheet
      onDismiss={onDismiss}
      planDetails={planDetails}
      isLoading={isLoading}
      isFetchFailed={isFetchFailed}
      onRetry={onRetry}
      recommendation={recommendation}
      manageSipCta={manageSipCta}
    />
  )
}
